import React, { PureComponent } from 'react'
// import "./style.scss";
import LoginInternal from "@/components/login-internal";

export default class index extends PureComponent {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <div className="market-material-page">
                <LoginInternal appendPath="/in-app-specs" />
            </div>
        )
    }
}
